import React from 'react';
import PropTypes from 'prop-types';
import { Flex, FormHelp, Input, Label } from '@zillow/constellation';
import styled from 'styled-components';

export function LabeledInput({
  input: inputProps,
  meta: { error, active, touched },
  label,
  className,
  inputClassName,
  id,
  required = false,
  ...otherProps
}) {
  const errorElementId = `${id}-help`;
  const isInvalid = touched && !active && Boolean(error);
  return (
    <Flex display="flex" flexDirection="column" className={className}>
      <Label controlId={id} required={required}>
        {label}
      </Label>
      <Input
        id={id}
        aria-invalid={isInvalid}
        aria-describedby={errorElementId}
        {...otherProps}
        {...inputProps}
        className={inputClassName}
      />
      {isInvalid && (
        <FormHelp id={errorElementId} error={Boolean(error)}>
          {error}
        </FormHelp>
      )}
    </Flex>
  );
}

LabeledInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }).isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  required: PropTypes.bool,
};

export default styled(LabeledInput)``;
